<template>
  <div class="content-body tenant-settings">
    <div class="">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" size="small">
        <el-form-item label="子公司" prop="subcompanyId">
          <el-select multiple v-model="subcompanyId" @change="getSupCompanyList" class="input-width">
            <el-option
                v-for="item in supCompanyList"
                :key="item.id"
                :label="item.orgName"
                :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="工厂:">
          <el-select v-model="dataForm.werks" filterable clearable placeholder="请选择工厂" @change="getDataList">
            <el-option v-for="item in factoryList" :key="item.factoryCode" :label="item.factoryCode" :value="item.factoryCode">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="物料编码:">
          <el-input size="small" v-model="dataForm.matnr" placeholder="物料编码" clearable @blur="getDataList"></el-input>
        </el-form-item>
        <el-form-item label="物料名称:">
          <el-input size="small" v-model="dataForm.matName" placeholder="物料名称" clearable @blur="getDataList"></el-input>
        </el-form-item>
        <el-form-item label="是否同步:" label-width="100px">
          <el-select size="small" v-model="dataForm.syncStatus" clearable @change="getDataList">
            <el-option v-for="(item,index) in syncStatusQuota" :key="index" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="截止日区间:" label-width="100px">
          <el-date-picker v-model="dataForm.deadlineDate" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" clearable @blur="getDataList">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="价格协议编码:">
          <el-input size="small" v-model="dataForm.priceAgreementCode" placeholder="价格协议编码" clearable @blur="getDataList"></el-input>
        </el-form-item>
        <el-form-item class="fr">
          <el-button size="small" @click="getDataList()" icon="el-icon-search">
            查询
          </el-button>
          <el-button size="small" plain type="primary" @click="exportQuotaMaterialData()">
            批量导出
          </el-button>
          <el-button size="small" plain v-if="isAuth('mdata:quotaMaterial:sendSAPs')" type="warning" @click="pushSaps()" icon="el-icon-plus">
            批量推送SAP
          </el-button>
        </el-form-item>
      </el-form>
      <div v-loading="dataListLoading">
        <el-table :header-cell-style="{background:'#f5f5f5'}" :row-class-name="rowClassName" @selection-change="selectionChangeHandle" border :data="dataList" size="mini" style="width: 100%;" :height="tableHeight">
          <el-table-column type="selection" :selectable='checkboxSelect' width="55">
          </el-table-column>
          <el-table-column type="index" width="50" label="序号">
            <template slot-scope="scope">
              {{ scope.row.rowid }}
            </template>
          </el-table-column>
          <el-table-column prop="syncStatus" header-align="center" align="center" label="同步状态" width="100">
            <template slot-scope="scope">
              <span :class="getStatusClass(scope.row.syncStatus)">{{getSyncStatus(scope.row.syncStatus)}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="matnr" header-align="center" align="center" label="物料编码" width="160">
          </el-table-column>
          <el-table-column prop="matName" header-align="center" align="center" label="物料名称" width="220">
          </el-table-column>
          <el-table-column prop="werks" header-align="center" align="center" label="工厂" width="150">
            <template slot-scope="scope">
              <span>{{scope.row.werks}}</span>
            </template>
          </el-table-column>

          <!-- A点 -->
          <el-table-column header-align="center" align="center" label="A点" width="300">
            <el-table-column prop="lifnr1" header-align="center" align="center" label="供应商代码" width="100">
            </el-table-column>
            <el-table-column prop="lifnr1Name" header-align="center" align="center" label="供应商名称" width="100">
            </el-table-column>
            <el-table-column prop="quote1" header-align="center" align="center" label="配额" width="100">
            </el-table-column>
          </el-table-column>

          <!-- B点 -->
          <el-table-column header-align="center" align="center" label="B点" width="300">
            <el-table-column prop="lifnr2" header-align="center" align="center" label="供应商代码" width="100">
            </el-table-column>
            <el-table-column prop="lifnr2Name" header-align="center" align="center" label="供应商名称" width="100">
            </el-table-column>
            <el-table-column prop="quote2" header-align="center" align="center" label="配额" width="100">
            </el-table-column>
          </el-table-column>

          <!-- C点 -->
          <el-table-column header-align="center" align="center" label="C点" width="300">
            <el-table-column prop="lifnr3" header-align="center" align="center" label="供应商代码" width="100">
            </el-table-column>
            <el-table-column prop="lifnr3Name" header-align="center" align="center" label="供应商名称" width="100">
            </el-table-column>
            <el-table-column prop="quote3" header-align="center" align="center" label="配额" width="100">
            </el-table-column>
          </el-table-column>

          <!-- D点 -->
          <el-table-column header-align="center" align="center" label="D点" width="300">
            <el-table-column prop="lifnr4" header-align="center" align="center" label="供应商代码" width="100">
            </el-table-column>
            <el-table-column prop="lifnr4Name" header-align="center" align="center" label="供应商名称" width="100">
            </el-table-column>
            <el-table-column prop="quote4" header-align="center" align="center" label="配额" width="100">
            </el-table-column>
          </el-table-column>

          <!-- E点 -->
          <el-table-column header-align="center" align="center" label="E点" width="300">
            <el-table-column prop="lifnr5" header-align="center" align="center" label="供应商代码" width="100">
            </el-table-column>
            <el-table-column prop="lifnr5Name" header-align="center" align="center" label="供应商名称" width="100">
            </el-table-column>
            <el-table-column prop="quote5" header-align="center" align="center" label="配额" width="100">
            </el-table-column>
          </el-table-column>

          <el-table-column prop="createByName" header-align="center" align="center" label="创建人" width="100">
          </el-table-column>
          <el-table-column prop="updateByName" header-align="center" align="center" label="更新人" width="100">
          </el-table-column>
          <el-table-column prop="vdatu" header-align="center" align="center" label="起始日期" :formatter="dateFormat" width="150">
          </el-table-column>
          <el-table-column prop="bdatu" header-align="center" align="center" label="有效至" :formatter="dateFormat" width="150">
          </el-table-column>
          <el-table-column prop="transactionMessage" header-align="center" align="center" label="同步结果信息" width="200">
          </el-table-column>
          <el-table-column header-align="center" align="center" width="240" label="操作" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="viewHandle(scope.row)" icon="el-icon-view">
                查看
              </el-button>
              <el-button type="text" :disabled="scope.row.syncStatus == 1 ? true : false" v-if="isAuth('mdata:quotaMaterial:sendSAP')" size="small" @click="pushSap(scope.row)" icon="el-icon-edit">
                同步
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
      </div>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
      <quota-material-import v-if="quotaMaterialImportVisible" @refreshDataList="getDataList" ref="quotaMaterialImport"></quota-material-import>
    </div>
  </div>
</template>


<script>
import {
    getFactoryList,
    fetchQuotaMaterialList,
    deleteQuotaMaterial,
    deleteQuotaMaterialList,
    exportQuotaMaterial,
    pushSapBack
} from '@/controller/systemData'
import {
    SYNC_STATUS_QUOTA,
} from '@/utils/const'
import AddOrUpdate from './quotaMaterial-add-or-update'
import QuotaMaterialImport from './quotaMaterial-import'
import moment from 'moment'
import {supCompanyList} from "../../../../controller/sys";
export default {
    data() {
        return {
            dataForm: {
                id:'',
                matnr: '',//物料编码
                werks: '',//工厂
                scmng: '',//最小分拆量
                vdatu: '',//起始日期
                bdatu: '',//有效至
                syncStatus:'',//是否同步
                deadlineDate:'',//截止日区间
                priceAgreementCode:'',//价格协议编号
            },
            dataList: [],
            factoryList : [],
            tenantList: [],
            pageIndex: 1,
            pageSize: 50,
            totalPage: 0,
            dataListLoading: false,
            dataListSelections: [],
            addOrUpdateVisible: false,
            quotaMaterialImportVisible: false,
            SYNC_STATUS_QUOTA: SYNC_STATUS_QUOTA,// 同步状态
            subcompanyId:'',
            supCompanyList: [],
        }
    },
    computed: {
        tableHeight: {
            get() {
                return this.$store.state.common.documentClientHeight - 270
            }
        },
        syncStatusQuota: function () {
            return this.SYNC_STATUS_QUOTA.filter(function (user) {
                
            return user.value == 3 ? user.isActiv : !user.isActiv
            })
        }

    },

    components: {
        AddOrUpdate,
        QuotaMaterialImport
    },
    activated() {
        this.getDataList()
        this.getFactoryList()
    },
    methods: {
        dateFormat: function (row, column) {
            var date = row[column.property]
            if (!date) {
                return ''
            }
            return moment(date).format("YYYY-MM-DD")
        },
        //查询条件导出
        exportQuotaMaterialData(){
            if(this.dataForm.matnr === ''
                && this.dataForm.matName === ''
                && this.dataForm.werks === ''
                && this.dataForm.syncStatus === ''
                && this.dataForm.priceAgreementCode === ''){
                 this.$message.error('请输入查询条件导出')
                 return
            }
            this.getSupCompanyList();
            const params = {
                'matnr': this.dataForm.matnr,
                'werks': this.dataForm.werks,
                'scmng': this.dataForm.scmng,
                'vdatu': this.dataForm.vdatu,
                'bdatu': this.dataForm.bdatu,
                'syncStatus': this.dataForm.syncStatus,
                'priceAgreementCode': this.dataForm.priceAgreementCode,
                'deadlineDateStart': this.dataForm.deadlineDate==null?this.dataForm.deadlineDate:this.dataForm.deadlineDate[0],//截止日区间开始
                'deadlineDateEnd': this.dataForm.deadlineDate==null?this.dataForm.deadlineDate:this.dataForm.deadlineDate[1],//截止日区间结束
                'subcompanyIdList':this.subcompanyId,
            }
            exportQuotaMaterial(params).then((data) => {
                if(data && data.code == '00') {
                    this.readAsBinaryString(data.body)
                    this.$message.success({
                        message: '操作成功',
                        type: 'success',
                        onClose: () => {
                        }
                    })
                } else {
                    this.$message.error(data.msg)
                }
            })
        },
         // 工厂名称
        getFactoryList() {
            getFactoryList({
                factoryCode: "",
                factoryDesc: "",
                address: "",
                post: "",
            }).then(data => {
                if (data && data.code === '00') {
                    this.factoryList = data.body;
                }
            });
        },
        getFactoryName(code) {
            const factory = this.factoryList.find(factory => factory.factoryCode === code)
            return factory ? factory.factoryDesc : ''
        },
        //获取同步状态 
        getSyncStatus(val) {
            var type = this.SYNC_STATUS_QUOTA.find(type => type.value === val)
            return type ? type.label : ''
        },
      //获取子公司列表
      getSupCompanyList(){
        supCompanyList().then(res=>{
          if(res && res.code == '00'){
            this.supCompanyList = res.body;
          }
        })
      },
        // 获取数据列表
        getDataList() {
            this.dataListLoading = true
            this.getSupCompanyList();
            fetchQuotaMaterialList({
                pageNo: this.pageIndex,
                pageSize: this.pageSize,
                'matnr': this.dataForm.matnr,
                'werks': this.dataForm.werks,
                'scmng': this.dataForm.scmng,
                'vdatu': this.dataForm.vdatu,
                'bdatu': this.dataForm.bdatu,
                'syncStatus': this.dataForm.syncStatus,
                'priceAgreementCode': this.dataForm.priceAgreementCode,
                'deadlineDateStart': this.dataForm.deadlineDate==null?this.dataForm.deadlineDate:this.dataForm.deadlineDate[0],//截止日区间开始
                'deadlineDateEnd': this.dataForm.deadlineDate==null?this.dataForm.deadlineDate:this.dataForm.deadlineDate[1],//截止日区间结束
                'subcompanyIdList':this.subcompanyId,
            }).then(data => {
                if (data && data.code === '00') {
                    this.dataList = data.body.records
                    this.totalPage = data.body.total
                } else {
                    this.dataList = []
                    this.totalPage = 0
                }
                this.dataListLoading = false
            })
        },
        readAsBinaryString(data) {
            // const name = decodeURI(res.headers['content-disposition'].split('filename=')[1]);
            // const blob = new Blob(content, {type: 'application/vnd.ms-excel;charset=utf-8'}); // 创建一个类文件对象：Blob对象表示一个不可变的、原始数据的类文件对象
            const blob = this.str2Blob(data.content, 'application/vnd.ms-excel;charset=utf-8'); // 创建一个类文件对象：Blob对象表示一个不可变的、原始数据的类文件对象
            const url = window.URL.createObjectURL(blob); // URL.createObjectURL(object)表示生成一个File对象或Blob对象
            let dom = document.createElement('a'); // 设置一个隐藏的a标签，href为输出流，设置download
            dom.style.display = 'none';
            dom.href = url;
            dom.setAttribute('download', decodeURI(data.fileName)); // 指示浏览器下载url,而不是导航到它；因此将提示用户将其保存为本地文件
            document.body.appendChild(dom);
            dom.click();
        },
        str2Blob(str, mime) {
            var arr = str.split(',')
            var bstr = atob(arr[0]),
                n = bstr.length,
                u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new Blob([u8arr], {
                type: mime
            });
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val
            this.pageIndex = 1
            this.getDataList()
        },
        // 当前页
        currentChangeHandle(val) {
            debugger
            this.pageIndex = val
            this.getDataList()
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val
        },
        // 查看
        viewHandle(row) {
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(row, row ? row.id : null, 'view')
            })
        },
        // 新增 / 修改
        addOrUpdateHandle(row) {
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(row, row ? row.id : null, 'edit')
            })
        },
        // 批量删除
        deleteList(){
            if(this.dataListSelections.length == 0){
                this.$message.warning("请选择数据")
                return
            }
            this.$confirm('当前共选中'+this.dataListSelections.length+'条数据进行批量删除。', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const idList = [];
                for (let index = 0; index < this.dataListSelections.length; index++) {
                    if(this.dataListSelections[index].syncStatus == 3){
                        this.$message.warning("已同步的数据不能删除")
                        return
                    }
                    idList.push(this.dataListSelections[index].id);
                }
                deleteQuotaMaterialList(idList).then(data => {
                    if(data.code === '00'){
                        this.$message.success({
                        message: '删除成功',
                        type: 'success',
                        duration: 1500,
                        onClose: () => {
                            this.getDataList()
                        }
                    })
                    }else{
                        this.$message.error(data.msg);
                    }
                })
            })
        },
        // 删除
        deleteHandle(row) {
            this.$confirm(`确定进行删除操作?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteQuotaMaterial({}, row.id).then(data => {
                    if (data && data.code === '00') {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.getDataList()
                            }
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            })
        },
        //批量导入
        importTemplate() {
            this.quotaMaterialImportVisible = true
            this.$nextTick(() => {
                this.$refs.quotaMaterialImport.init()
            })
        },
        getStatusClass(status) {
            let className = ''
            switch (status) {
                case 0:
                    className = "text-primary"
                    break;
                case 2:
                    className = "text-danger"
                    break;
                default:
                    className = 'text-success'
                    break;
            }
            return className
        },
        //禁用checkbox
        checkboxSelect (row, rowIndex) {
            if (row.syncStatus == 1) {
                return false // 禁用
            }else{
                return true // 不禁用
            }
        },
        //批量推送sap
        pushSaps(){
            if(this.dataListSelections.length == 0){
                this.$message.warning("请选择数据")
                return
            }
            this.$confirm('当前共选中'+this.dataListSelections.length+'条数据进行批量推送。', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const zguidList = [];
                for (let index = 0; index < this.dataListSelections.length; index++) {
                    zguidList.push(this.dataListSelections[index].zguid);
                }
                pushSapBack(zguidList).then(data => {
                    if(data.code === '00'){
                        this.$message.success({
                        message: '推送成功',
                        type: 'success',
                        duration: 1500,
                        onClose: () => {
                            this.getDataList()
                        }
                    })
                    }else{
                        this.$message.error(data.msg);
                    }
                })
            })
        },
        //推送sap
        pushSap(row){
            const zguidList = [];
            zguidList.push(row.zguid);
            pushSapBack(zguidList).then(data => {
                 if(data.code === '00'){
                    this.$message.success({
                      message: '推送完成',
                      type: 'success',
                      duration: 1500,
                      onClose: () => {
                          this.getDataList()
                      }
                  })
                 }else{
                      this.$message.error(data.msg);
                 }
            })
        },
        rowClassName({
                         row,
                         rowIndex
                     }) {
            //把每一行的索引放进row.id
            row.rowid = rowIndex + 1 + (this.pageSize * (this.pageIndex - 1));
        },
        tableRowClassName({row, rowIndex}) {
           var day = this.difference(row.bdatu,Date.now())
            if (day<=30 && day>0) {
                return 'warning-row';
            } else if (day>30 && day<=60) {
                return 'success-row';
            }
            return '';
        },
        // 时间差计算
        difference(beginTime, endTime) {
            var dateBegin = new Date(beginTime);
            var dateEnd = new Date(endTime);
            var dateDiff = dateBegin.getTime() - dateEnd.getTime(); //时间差的毫秒数
            var dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000)); //计算出相差天数
            // var leave1 = dateDiff % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
            // var hours = Math.floor(leave1 / (3600 * 1000)); //计算出小时数
            //计算相差分钟数
            // var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
            // var minutes = Math.floor(leave2 / (60 * 1000)); //计算相差分钟数
            //计算相差秒数
            // var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
            // var seconds = Math.round(leave3 / 1000);
            return dayDiff;
        },
    }
}
</script>
<style>
  .el-table .warning-row {
    background: #FACD91;
  }

  .el-table .success-row {
    background: #FFFF80;
  }
</style>